export const MAX_TECHNOLOGY_ROW_WIDTH = 268;